const MatxLogo = ({ className }) => {
  return (
    <>
      <img src="/assets/images/memosign.png" className={className} alt="Memo Sign"/>
    </>
  );
};

export default MatxLogo;
